import moment from "moment";
import React from "react";
import { useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Col, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import * as S from "src/constants/StringConstants";

const DeliveryRequirementsRequirement = "DELREQ";

interface RequirementFormProps {
  reqDetails: any;
}

const RequirementForm = ({ reqDetails }: RequirementFormProps) => {
  const form = useForm();
  return (
    <Row>
      <Col sm="6">
        <Row>
          <Col>
            <TypeaheadField
              name="requirementCodeCode"
              label={S.APP_REQS_ADD_FIELD_CODE}
              options={reqDetails?.selectRequirementCodeList}
            />
            <OnChange name="requirementCodeCode">
              {value => {
                const selectedOption = (reqDetails?.selectRequirementCodeList || []).find(
                  option => option.value === value,
                );
                form.change("requirementDescription", selectedOption?.key);
                const origin = selectedOption?.requirementOriginCode;
                if (origin) {
                  form.change("requirementOriginCode", origin);
                }
                if (value === DeliveryRequirementsRequirement) {
                  form.change(
                    "followUp",
                    moment(new Date())
                      .add(7 * 3, "days")
                      .toISOString(),
                  );
                }
              }}
            </OnChange>
          </Col>
          <Col>
            <SimpleDatePickerField name="agencyOrdered" label={S.APP_REQS_ADD_FIELD_ORDERED} isFormMode showClear />
          </Col>
        </Row>
        <Row>
          <Col>
            <TypeaheadField
              name="requirementOriginCode"
              label={S.APP_REQS_ADD_FIELD_FROM}
              options={reqDetails?.selectRequiredOriginList}
            />
          </Col>
          <Col>
            <SimpleDatePickerField name="agencyReceived" label={S.APP_REQS_ADD_FIELD_RECEIVED} isFormMode showClear />
          </Col>
        </Row>
        <Row>
          <Col>
            <TypeaheadField
              name="requirementStatusID"
              label={S.APP_REQS_ADD_FIELD_STATUS}
              options={reqDetails?.selectStatusList}
            />
          </Col>
          <Col>
            <SimpleDatePickerField name="followUp" label={S.APP_REQS_ADD_FIELD_FOLLOWUP} isFormMode showClear />
          </Col>
        </Row>
        <Row>
          <Col></Col>
          <Col>
            <CheckboxField name="priority" label={S.APP_REQS_ADD_FIELD_PRIORITY} />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextField name="requirementDescription" label={S.APP_REQS_ADD_FIELD_DESCRIPTION} />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextField name="notes" label={S.APP_REQS_ADD_FIELD_NOTES} multiline />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default RequirementForm;
